import React from 'react';
import { IOT } from '@src/helpers/_iot';
import { Pillar } from '@interfaces/pillar';
import Unit from '@interfaces/IUnit';

type ContextType = {
    theme?: any;
    units?: Unit[];
    activeUnitId: string;
    client?: any;
    pillar?: any;
    user?: any;
    roles?: any;
    iot?: IOT;
    locale: string;
    authorized?: boolean;
    token?: any;
    ChangeLocale: (nextLocale: string) => void;
    ChangePillar: (nextPillar: Pillar) => void;
    ChangeUnit: (nextUnit: string) => void;
    Login: (username: string, password: string) => void;
    Logout: () => void;
    isLoggingIn: boolean;
    updateUnits?: Function;
    visibleOnboarding?: any;
    onChangeVisibleOnboarding?: any;
    userPermissions?: any;
    defaultPermissions?: any;
    updateNotification?: any;
    updateNotificationVar?: any;
    scheduled?: any;
    loadSchedules?: any;
};

export default React.createContext({} as ContextType);
